import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

const SvgOk = () => {
  return (
<svg version="1.1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 500 500" width="42px" height="42px" fill="#000000">
<g   fill="none" stroke="#000" stroke-width="4">
<path fill="#fff" d="M455.3,61.5C395.6,69.1,300.9,153.7,222,276c-6.1,9.4-11.9,18.8-17.4,28.1c0,0,0,0-0.1-0.1 c-0.1,0.1-0.1,0.2-0.2,0.3c-12.8-12.8-26.6-25.6-41.2-38.1c-6.8-5.8-13.6-11.4-20.3-16.9L40.2,314.2c46.9,22,87.8,48.2,119.6,75.3 c0-0.1,0.1-0.2,0.1-0.3c19.1,16.3,35,33,46.8,49.3c5.2-7.7,10.5-15.4,16-23.2c12-17.1,24.2-33.5,36.4-49.1c0,0,0.1,0.1,0.1,0.1 c81.4-104.5,162.3-173.5,200.6-170.6L455.3,61.5z"></path> 
</g>
</svg>
);
};
function DataParaDb(dataEntrada) {
    const [year, month, day ] = dataEntrada.split("-"); 
    const formattedDate = `${month}/${day}/${year}`;  
    return formattedDate; 
  }   
  

function FormClienteNovo() {
    const navigate = useNavigate(); // Inicialize o hook


  const [formData, setFormData] = useState({
    Id: "",
    Tipo: "",
    Nome: "",
    DataAte: "",
    Situacao: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    for (const key in formData) {
      if (key === "DataAte")  {formData[key] = DataParaDb(formData[key]); };
      if (key === "Situacao")  {
        if (formData[key] === "") {
          formData[key] = "Ativo"; }};
        //alert(key+ formData[key]);
        params.append(key, formData[key]);
    }
    console.log('params----->', params, formData);
    alert('params----->'+ params + formData);
    navigate("/FormCli");
    const response = await fetch('http://www.criar.com.br:3000/usonovo', {
      method: "POST",
      headers: {"Content-Type": "application/json", },
      body: JSON.stringify(formData),
    });
    
    console.log('data----->');
    const data = await response.json();
    console.log(' >>>>>>>>>>>>>>>>>>>>>>',data);
    
  };

  /*const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); 
  formData.Id = id;
  useEffect(() => {
    fetch(`http://www.criar.com.br:3000/usonovo`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Erro ao buscar os dados!");
        }
        return response.json();
      })
      .then(data => {
        setFormData(prevState => ({ ...prevState, Tipo:data.Tipo, Nome:data.Nome, 
          DataAte:data.DataAte, Situacao:data.Situacao }));        
        console.log('data-0---->');
        

      })
      .catch(error => console.error("Erro ao buscar os dados:", error));
  }, [id, setFormData]);
  */
  
   return (

<div class="areabox">
	
	<h1>Cliente</h1>
		<div class='row'>
		<div class='col-p'>
			<div class='card1'>
			</div>
		</div>
		<div class='col-4'>
			<div class='card1'>
				<h2>Incluir</h2>

<form onSubmit={handleSubmit}>
<div class="form-group">

<label for="Tipo" class="form-control">Tipo:</label><br/>
<input type="text" name="Tipo"     size="30" value={formData.Tipo} onChange={handleChange}/><br /><br />

<label for="Nome" class="form-control">Nome:</label><br/>
<input type="text" name="Nome"     size="60" value={formData.Nome} onChange={handleChange} /><br /><br />

<label for="DataAte" class="form-control">Data Até:</label><br/>
<input type="date" name="DataAte"  size="50" value={formData.DataAte} onChange={handleChange} /> <br /><br />

<label for="Situacao" class="form-control">Situação:</label><br/>
<select name="Situacao" size="1" value={formData.Situacao} onChange={handleChange}>
<option value="Ativo">Ativo</option>
<option value="Inativo">Inativo</option>
<option value="Em Dia">Em Dia</option>
<option value="Em Atrazo">Em Atrazo</option>
<option value="Cancelado">Cancelado</option>
</select>

<br /><br />

<button type="submit" class="botaocinsa"><SvgOk/><br/>Incluir</button><br/><br/>

</div>
</form>

</div>
</div>
	</div>
</div>  



  );
}

export default FormClienteNovo;